export class HistoricoMovimientos{
  id     : number | undefined;
  tipo       : string | undefined;
  elemento   : string | undefined;
  anterior      : string | undefined;
  usuario          : string | undefined;
  fecha : Date | undefined;
}
